var exports = {
  "k": "x112a1f60--2c156f--container",
};

module.exports = exports;
